import * as React from 'react'

const CheckMark = (props: { className: string }) => (
  <svg
    className={'icon' + props.className}
    width='17'
    height='12'
    viewBox='0 0 17 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M16 1L6.11535 10L1 4.74981' stroke='#fff' strokeWidth='2.5' />
  </svg>
)

export default CheckMark



// WEBPACK FOOTER //
// ./src/components/icons/ui/CheckMark.tsx